export default __webpack_public_path__ + "static/media/Intelligent-Quality.e721a341.svg";